import { render, staticRenderFns } from "./amazon-shopify.vue?vue&type=template&id=2af5ec72&scoped=true&"
import script from "./amazon-shopify.vue?vue&type=script&lang=js&"
export * from "./amazon-shopify.vue?vue&type=script&lang=js&"
import style0 from "./amazon-shopify.vue?vue&type=style&index=0&id=2af5ec72&prod&lang=scss&scoped=true&"
import style1 from "./amazon-shopify.vue?vue&type=style&index=1&id=2af5ec72&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af5ec72",
  null
  
)

export default component.exports